import React from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
const SERVICE_CATEGORIES = [{
  name: 'Accessories',
  description: 'Curated selection of decorative accessories, artwork, and finishing touches that bring personality and polish to any space.',
  link: '/23m8/accessories.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2FAccessories2.JPG'
}, {
  name: 'Apparel',
  description: 'Boutique clothing and jewelry collection featuring timeless pieces that complement your personal style.',
  link: '/23m8/apparel.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FCategory%20Images%2Fapparel.JPG'
}, {
  name: 'Bathrooms',
  description: 'Complete bathroom design from layout planning to fixture selection, creating spa-like retreats in your home.',
  link: '/23m8/bathrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBathrooms%2FBathroom5.jpg'
}, {
  name: 'Bedrooms',
  description: "Restful bedroom designs that balance comfort and style, from master suites to guest rooms and children's spaces.",
  link: '/23m8/bedrooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FBedrooms1.JPG'
}, {
  name: 'Before & After',
  description: 'Transformative design projects that showcase the power of thoughtful planning and expert execution.',
  link: '/23m8/before-after.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBefore%20%26%20After%2F140508121027.jpg'
}, {
  name: 'Commercial',
  description: 'Professional interior design for offices, retail spaces, and hospitality venues that enhance your brand and customer experience.',
  link: '/23m8/commercial.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013937.jpg'
}, {
  name: 'Dining Rooms',
  description: 'Elegant dining spaces designed for both everyday meals and special occasions, with attention to flow and functionality.',
  link: '/23m8/dining-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014171.jpg'
}, {
  name: 'Furniture',
  description: 'Quality furniture selection and custom pieces that anchor your rooms with style and substance.',
  link: '/23m8/furniture.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FNew_Temp%2FBedrooms%2FIMG_9817.JPG'
}, {
  name: 'Kitchens',
  description: 'Kitchen design that balances beauty and function, from layout optimization to material selection and styling.',
  link: '/23m8/kitchens.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014168.jpg'
}, {
  name: 'Lighting',
  description: 'Lighting design and fixture selection that sets the mood, highlights architecture, and enhances daily living.',
  link: '/23m8/lighting.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flighting%20and%20bathroom.jpg'
}, {
  name: 'Living Rooms',
  description: 'Inviting living spaces designed for how you actually live, with comfortable seating arrangements and thoughtful layouts.',
  link: '/23m8/living-rooms.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1014111.jpg'
}, {
  name: 'Lower Levels',
  description: 'Basement and lower level transformations that maximize square footage with family rooms, home theaters, and recreation spaces.',
  link: '/23m8/lower-levels.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2Flower%20level.jpg'
}, {
  name: 'Seminars and Events',
  description: 'Educational workshops and design events where we share our expertise and connect with the community.',
  link: '/23m8/seminars-and-events.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FIMG_3233.jpg'
}, {
  name: 'Staging',
  description: 'Professional real estate staging that helps homes sell faster and for more by showcasing their best features.',
  link: '/23m8/staging.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FBlog%20Images%2Fclutter%20free.jpg'
}, {
  name: 'Window Treatments',
  description: 'Custom drapery, blinds, and shades designed to enhance your windows while providing privacy and light control.',
  link: '/23m8/window-treatments.html',
  image: 'https://www.downhomeinteriors.com/uploaded%2Fimages%2FP1013895.jpg'
}];
export function Services() {
  return <Layout data-id="element-483">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-484">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-485">
          <img src="https://cdn.magicpatterns.com/uploads/uC7yBiRHmqgmNVwY8ECDES/services_bg.jpg" alt="Down Home Interiors Services" className="w-full h-full object-cover object-center" data-id="element-486" />
          <div className="absolute inset-0 bg-white/80" data-id="element-487" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-488">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-489">
            What We Offer
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-490">
            Design Services &<br data-id="element-491" />
            <span className="italic" data-id="element-492">Retail Offerings</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-493">
            From full-service interior design to curated home décor and
            professional staging—everything you need under one roof.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-20 px-4 bg-white border-b border-taupe-200" data-id="element-494">
        <div className="max-w-4xl mx-auto text-center" data-id="element-495">
          <h2 className="text-2xl md:text-3xl font-serif text-charcoal-900 mb-6" data-id="element-496">
            Comprehensive Design Solutions
          </h2>
          <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-497">
            Each category below represents an area of expertise where we've
            completed hundreds of projects over the past 20 years. Whether you
            need full-service design, retail products, or professional staging,
            we bring the same level of care and attention to every engagement.
          </p>
          <p className="text-lg text-charcoal-900/70 leading-relaxed" data-id="element-498">
            Browse our focus areas to understand the scope of what we offer,
            then explore our portfolio to see real examples of our work.
          </p>
        </div>
      </section>

      {/* Service Categories Grid */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-499">
        <div className="max-w-7xl mx-auto" data-id="element-500">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-501">
            {SERVICE_CATEGORIES.map(service => <div key={service.name} className="bg-white border border-taupe-200 overflow-hidden hover:shadow-soft transition-shadow duration-300" data-id="element-502">
                {/* Service Image */}
                <a href={service.link} className="block" data-id="element-503">
                  <img src={service.image} alt={service.name} className="aspect-[4/3] w-full object-cover border-b border-taupe-200" data-id="element-504" />
                </a>

                <div className="p-6" data-id="element-505">
                  <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-506">
                    {service.name}
                  </h3>
                  <p className="text-charcoal-900/70 leading-relaxed text-sm mb-4" data-id="element-507">
                    {service.description}
                  </p>
                  <a href={service.link} data-id="element-508">
                    <Button variant="ghost" size="sm" className="text-xs" data-id="element-509">
                      View Examples →
                    </Button>
                  </a>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 px-4 bg-white" data-id="element-510">
        <div className="max-w-5xl mx-auto" data-id="element-511">
          <div className="text-center mb-16" data-id="element-512">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-513">
              Our Design Process
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-514">
              How we bring your vision to life
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-515">
            {[{
            step: '01',
            title: 'Consultation',
            description: 'We start by listening. Understanding your lifestyle, preferences, and goals is essential to creating spaces that work for you.'
          }, {
            step: '02',
            title: 'Design Development',
            description: 'We create detailed plans, select materials and furnishings, and present options that align with your vision and budget.'
          }, {
            step: '03',
            title: 'Sourcing & Ordering',
            description: 'Leveraging our extensive vendor relationships, we source quality products and manage all ordering, tracking, and coordination.'
          }, {
            step: '04',
            title: 'Installation',
            description: 'We oversee delivery, placement, and styling to ensure every detail is perfect. Your satisfaction is our priority.'
          }].map(phase => <div key={phase.step} className="text-center" data-id="element-516">
                <div className="text-4xl font-serif text-sage-500 mb-4" data-id="element-517">
                  {phase.step}
                </div>
                <h3 className="text-xl font-serif text-charcoal-900 mb-3" data-id="element-518">
                  {phase.title}
                </h3>
                <p className="text-charcoal-900/70 leading-relaxed text-sm" data-id="element-519">
                  {phase.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-520">
        <div className="max-w-5xl mx-auto" data-id="element-521">
          <div className="text-center mb-16" data-id="element-522">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-523">
              The Down Home Difference
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-524">
            {['Personalized service from an experienced owner-operator', 'Over 20 years of proven design expertise', 'Full-service approach from concept to installation', 'Local showroom with curated retail offerings', 'Extensive network of trusted contractors and craftspeople', 'Timeless design philosophy that ages gracefully', 'Transparent pricing and clear communication', 'Commitment to your satisfaction and long-term happiness'].map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-525">
                <div className="flex-shrink-0 w-6 h-6 bg-sage-500 rounded-full flex items-center justify-center mt-1" data-id="element-526">
                  <Check className="text-white" size={14} data-id="element-527" />
                </div>
                <p className="text-lg text-charcoal-900/80" data-id="element-528">{benefit}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 px-4 bg-white" data-id="element-529">
        <div className="max-w-4xl mx-auto text-center" data-id="element-530">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-531">
            Let's Discuss Your Project
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-532">
            Whether you're planning a complete renovation or looking for design
            guidance, we're here to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-533">
            <Link to="/portfolio" data-id="element-534">
              <Button size="lg" className="min-w-[200px]" data-id="element-535">
                View Our Portfolio
              </Button>
            </Link>
            <Link to="/contact" data-id="element-536">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-537">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>;
}